import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Item } from '../../../../../../../../../../../interfaces/api/ActivityWall';
import { createUseStyles } from '../../../../../../../../../../../theming';

interface Props {
  open: boolean;
  item: Item;
  onClose: () => void;
  onValidate: (title: string, comment: string) => void;
}

interface PostCommentOptions {
  title: string;
  comment: string;
}

const useStyles = createUseStyles({
  input: {
    marginTop: '8px !important',
  },
});

const UpdateRequestDialog: FC<Props> = ({ open, item, onValidate, onClose }) => {
  const [, setFormError] = useState<string>();
  const [, setLoading] = useState(false);
  const classes = useStyles();

  const { control, handleSubmit } = useForm<PostCommentOptions>({
    defaultValues: {
      comment: item.payload?.text || '',
      title: item.payload?.title || '',
    },
  });

  const onSubmit = async (postCommentOptions: PostCommentOptions) => {
    const { title, comment } = postCommentOptions;

    try {
      setLoading(true);
      setFormError(undefined);
      await onValidate(title, comment);
      onClose();
    } catch (e) {
      setFormError(e.message);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>Edition du commentaire</DialogTitle>

      <DialogContent>
        <Controller
          name='title'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              variant='outlined'
              placeholder='Titre du commentaire'
              fullWidth
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />

        <Controller
          name='comment'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              placeholder='Ecrivez un commentaire ...'
              fullWidth
              variant='outlined'
              multiline
              minRows={5}
              className={classes.input}
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button onClick={handleSubmit(onSubmit)} color='primary'>
          Mettre à jour
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRequestDialog;
